import { useTheme } from '@mui/material/styles';

export const COLOR_MODE = {
  ACTIVE_GROWTH: 0,
  ACTIVE_WHITE: 1
};

const useColorPalette = (colorMode) => {
  const { palette } = useTheme();
  let defaultColor;
  let hoverColor;
  let activeColor;

  switch (colorMode) {
    case COLOR_MODE.ACTIVE_GROWTH:
      defaultColor = palette.mode === 'light'
        ? palette.focus00.main
        : palette.focus60.main;
      activeColor = palette.mode === 'light'
        ? palette.growthBrand.main
        : palette.growth30.main;
      hoverColor = activeColor;
      break;
    case COLOR_MODE.ACTIVE_WHITE:
    default:
      defaultColor = palette.mode === 'light'
        ? palette.focus90.main
        : palette.focus60.main;
      hoverColor = palette.mode === 'light'
        ? palette.peace50.main
        : palette.peace30.main;
      activeColor = palette.mode === 'light'
        ? palette.focus00.main
        : palette.focus30.main;
  }

  return {
    defaultColor,
    hoverColor,
    activeColor
  };
};

export default useColorPalette;
